import React from 'react'

const DoneStep = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#068AE2" viewBox="0 0 24 24" {...props}>
    <path d="M12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10zm-1.55 14.614l-4.601-4.602 1.767-1.767 2.833 2.834 6.011-6.01 1.767 1.767-7.777 7.778z"/>
  </svg>
)

export default DoneStep
